const gravacaovoz = (state = [], action) => {
    switch (action.type) {
      case 'CHANGERECORDER':
        return action.gravacaovoz
      default:
        return state
    }
  }
  
  export default gravacaovoz